define('view/controller/booking/service/ServiceSplitterView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Service splitter view
     *
     * @class ServiceSplitterView
     */
    return LayoutView.extend({

        template: '#service_item_split'

    });

});
